@if (data.title) {
  <h1 mat-dialog-title>{{ data.title }}</h1>
}
<mat-dialog-content>
  <p [innerHTML]="data.message | safeHtml"></p>

  <mat-radio-group class="flex flex-col -ml-2.5" [formControl]="control" name="type">
    @for (option of data.options; track $index) {
      <mat-radio-button
        [value]="option.value"
        [checked]="option.checked"
        class="py-2 select-none"
      >
        <div>{{ option.label }}</div>
        @if (option.message) {
          <span class="text-xs text-gray-500">{{ option.message }}</span>
        }
      </mat-radio-button>
    }
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" [disabled]="submitted()">
    {{ data.cancelText }}
  </button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted()" cdkFocusInitial>
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">{{
      data.confirmText
    }}</span>
  </button>
</mat-dialog-actions>
